import { FormControlLabel, MenuItem, Select } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import decodeJwt from 'jwt-decode';
import { Button } from 'ra-ui-materialui';
import React, { useEffect } from 'react';
import { Error, Loading } from 'react-admin';
import XLSX from 'xlsx';
import ReportTable from '../../components/reports/ReportTable';
const config = require('./../../config.json');


const ReportMachines = () => {
    const [_year, setYear] = React.useState(2021);
    const [_month, setMonth] = React.useState(1);
    const [_year1, setYear1] = React.useState(2021);
    const [_month1, setMonth1] = React.useState(1);
    const [search, setSearch] = React.useState(false);
    const [_data, setData] = React.useState(null);
    const [_error, setError] = React.useState(null);
    const [_loading, setLoading] = React.useState(null);
    const [buildings, setBuildings] = React.useState([]);
    const [buildingId, setBuildingId] = React.useState(null);

    const searchFunction = () => {
        setSearch(true);
    }

    useEffect(() => {
        if (buildings.length === 0) {
            let a = '';
            if (localStorage.getItem('token')) {
                a = decodeJwt(localStorage.getItem("token")).access_token
            }
            fetch(config.API_URL + `/buildings?_end=500&_order=ASC&_sort=address&_start=0`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': a
                }
            })
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    setBuildings(data);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }, [buildings])

    useEffect(() => {
        if (search) {
            let a = '';
            if (localStorage.getItem('token')) {
                a = decodeJwt(localStorage.getItem("token")).access_token
            }
            setLoading(true);
            let url = config.API_URL + `/stats/monthly-machine?month=${_month}&year=${_year}`;
            if (buildingId !== null) {
                url += `&buildingId=${buildingId}`;
            }
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': a
                }
            })
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    setYear1(_year);
                    setMonth1(_month);
                    setData(data);
                    setLoading(false);
                })
                .catch(error => {
                    setError(error);
                    setLoading(false);
                });
            setSearch(false);
        }
    }, [search, _year, _month, buildingId]);

    if (_loading) return <Loading />;
    if (_error) return <Error />;
    if (search && !_data) return null;

    // Remove " and \ from content
    // data.event_information.data.forEach((obj: any) => {
    // obj.content = JSON.stringify(obj.content).replace(/(")|(\\)/g, '');
    // })

    const meses = {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre'
    }

    const handleChangeYear = (event) => {
        setYear(event.target.value);
        // setSearch(false);
    }

    const handleChangeMonth = (event) => {
        setMonth(event.target.value);
        // setSearch(false);
    }

    const handleChangeBuilding = (event) => {
        setBuildingId(event.target.value);
    }

    const handleDownload = () => {
        let workBook = XLSX.utils.book_new();

        workBook.Props = {
            Title: "Reporte uso máquinas y edificos al mes",
            Subject: "Reportes Speedclean",
            Author: "desarrollo@speedclean.cl",
            CreatedDate: new Date(Date.now()),
        };

        Object.keys(_data).forEach((reportKey) => {
            workBook.SheetNames.push(reportKey);
            workBook.Sheets[reportKey] = XLSX.utils.json_to_sheet(_data[reportKey]);
        })
        XLSX.writeFile(workBook, 'resumenMesMaquinaEdificio.xlsx');
    }
    return (
        <div>
            <FormControlLabel
                control={<Select
                    style={{ width: '30%' }}
                    onChange={handleChangeMonth}
                >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((id) => (
                        <MenuItem key={id} value={id}>{meses[id]}</MenuItem>
                    ))}
                </Select>
                }
                label="Seleccionar mes"
                labelPlacement="top"
                style={{ margin: 'auto', width: '100%' }}
            />
            <FormControlLabel
                control={<Select
                    style={{ width: '30%' }}
                    onChange={handleChangeYear}
                >
                    {[2021, 2022, 2023, 2024, 2025, 2026].map((id) => (
                        <MenuItem key={id} value={id}>{id}</MenuItem>
                    ))}
                </Select>
                }
                label="Seleccionar año"
                labelPlacement="top"
                style={{ margin: 'auto', width: '100%' }}
            />
            {buildings.length !== 0 &&
                <FormControlLabel
                    control={<Select
                        style={{ width: '30%' }}
                        onChange={handleChangeBuilding}
                    >
                        {[null, ...buildings].map((building) => {
                            if (building === null) {
                                return <MenuItem key={"sin-id"} value={null}>-</MenuItem>
                            }
                            return (
                                <MenuItem key={building.id} value={building.id}>{building.address}</MenuItem>
                            )
                        })}
                    </Select>
                    }
                    label="Seleccionar edificio (opcional)"
                    labelPlacement="top"
                    style={{ margin: 'auto', width: '100%' }}
                />}
            <br />
            <br />
            <Button
                variant="contained"
                color="primary"
                onClick={searchFunction}
                style={{ margin: 'auto', width: '30%', display: "flex", justifyContent: "center", alignItems: "center" }}
                label="Buscar"
            />
            {_data ?
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h1>Resumen por máquina y edificio - {meses[_month1]} {_year1}</h1>
                        <Button
                            onClick={handleDownload}
                            label="Descargar Reporte de máquinas"
                            style={{ height: '2.5rem' }}
                        >
                            <GetApp />
                        </Button>
                    </div>
                    <h2>Resumen de máquinas</h2>
                    <ReportTable headers={[
                        'Código',
                        'Ciclos pago',
                        'Monto asociado pago',
                        'Edificio',
                        'Ciclos personal',
                        'Monto asociado personal',
                    ]}
                        keyNames={[
                            'code',
                            'use',
                            'amount',
                            'address',
                            'use_personal',
                            'amount_personal',
                        ]}
                        data={_data.machines} />
                    <h2>Resumen de edificios</h2>
                    <ReportTable headers={[
                        'Edificio',
                        'Ciclos pago',
                        'Monto asociado pago',
                        'Ciclos personal',
                        'Monto asociado personal',
                    ]}
                        keyNames={[
                            'address',
                            'use',
                            'amount',
                            'use_personal',
                            'amount_personal',
                        ]}
                        data={_data.buildings} />
                </div>
                : <></>
            }
        </div>

    )
}

export default ReportMachines;